import { render, staticRenderFns } from "./ButtonChangeRead.vue?vue&type=template&id=2d540357&"
import script from "./ButtonChangeRead.vue?vue&type=script&lang=ts&"
export * from "./ButtonChangeRead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports